import React from "react";
import { useNavigate } from "react-router-dom";
import { Container, Col, Row } from "react-bootstrap";
import "./PricingPlan.css";
import ReadMore from "../../CommonUI/ReadMoreBtn/ReadMore";

function PricingPlan(props) {

  let pricing=window.location.pathname;
   pricing=pricing.replace('/','');
    let navigate = useNavigate();

  const PlanAClick = (evt) => {	   
      const plan = evt;
	   let path = `../Pricing`;
      if (props.product != 'Products') {
          props.Plan_details(plan);
          
          window.scrollTo({
              top: 1200,
              behavior: 'smooth',
          });
      }
	  else
          navigate(path, { state: { plan: evt } });
  };
  return (
    <>
      <section className="our-pricing">
        <Container className="add-border">
          <Row className="align-items-center">
            <Col md={4}>
              <div className="our-pricing-main">
                <h2>Our Pricing Plans</h2>
                
              </div>
            </Col>
            <Col md={4} sm={6}>
              {/* <div className="delivery-brokerage">
                <span>Plan A</span>
                <h1>0</h1>
                <h5>delivery brokerage</h5>
                <p>
                  Get ₹20/order + Zero Delivery Brokerage + Interest on YOUR
                  MARGIN to maximize your returns.
                </p>
              </div> */}
              <div className="plan-a" onClick={()=>PlanAClick('A')}>
                <h3>
                  <span>&#8377;</span>
                  20
                </h3>
                <p>Per order + FREE delivery Brokerage</p>
                <span className="plan-list">Plan A</span>
              </div>
              
            </Col>
            <Col md={4} sm={6}>
              {/* <div className="per-order">
                <span>Plan A</span>
                <h1>
                  <small>&#8377;</small>10
                </h1>
                <h5>per order</h5>
                <p>Get flat ₹10/order</p>
              </div> */}
              <div className="plan-b" onClick={()=>PlanAClick('B')}>
                <h3>
                  <span>&#8377;</span>
                  10
                </h3>
                <p> Per order only <br></br>( No hidden charges) </p>
                <span className="plan-list">Plan B</span>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
}
export default PricingPlan;
